import { Component, OnInit } from '@angular/core';
import { BrandService } from '../brand/brand.service';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: 'schoolsuspended.component.html',
  styleUrls: [
    './_pfcss/bootstrap.min.css',
    'schoolsuspended.component.css']
})
export class SchoolSuspendedComponent implements OnInit {

  brand = this.brandService.brand;
  constructor(private brandService: BrandService) { }

  ngOnInit() {
  }

}
